import {
  isPlanGatedQuizType,
  type PlanGatedQuizType,
} from '@/shared/plan/consts';
import { type QuizType } from '@/types';

type QuizWithOptionalType = {
  type?: string | null;
};

/**
 * 서버/폼이 섞어 쓰는 표기(대소문자·공백)를 정규화해 플랜 게이팅 대상 유형을 돌려준다.
 * 게이팅 대상이 아니면 `undefined` — 호출부가 유형별 문구·지표를 이걸로 고른다.
 */
export const resolveGatedQuizType = (
  type?: string | null,
): PlanGatedQuizType | undefined => {
  const normalized = type?.trim().toLowerCase() as QuizType | undefined;
  return normalized && isPlanGatedQuizType(normalized) ? normalized : undefined;
};

type ResolveRestrictedProQuizIndexesParams = {
  quizList: readonly QuizWithOptionalType[];
  hasProAccess: boolean;
};

export const resolveRestrictedProQuizIndexes = ({
  quizList,
  hasProAccess,
}: ResolveRestrictedProQuizIndexesParams): number[] => {
  if (hasProAccess) {
    return [];
  }

  return quizList.reduce<number[]>((restrictedIndexes, quiz, index) => {
    if (resolveGatedQuizType(quiz.type)) {
      restrictedIndexes.push(index);
    }

    return restrictedIndexes;
  }, []);
};
